import { LanguageData } from "@/domain/main-header/entity/LanguageData.interface";
import { IconName, LanguageCode } from "webshop-modules";
import { LanguageConfiguration } from "@/domain/main-header/entity/LanguageConfiguration.interface";
import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { IMainHeader } from "@/domain/main-header/entity/MainHeader.interface";

export class LanguageSwitchConfigurationProvider {

    private static availableLanguages: LanguageData[] = [
        {
            icon: IconName.Slovenia,
            languageISO: LanguageCode.Slovenian,
        },
        {
            icon: IconName.Croatia,
            languageISO: LanguageCode.Croatian,
        },
        {
            icon: IconName.Bulgaria,
            languageISO: LanguageCode.Bulgarian,
        },
        {
            icon: IconName.Romania,
            languageISO: LanguageCode.Romanian,
        },
        {
            icon: IconName.Hungary,
            languageISO: LanguageCode.Hungarian,
        },
        {
            icon: IconName.UnitedKingdom,
            languageISO: LanguageCode.English,
        }
    ];

    public static provideTo(mainHeaderApplicationData: Partial<IMainHeader>): Partial<IMainHeader> {
        const englishLanguageConfiguration = this.getEnglishLanguageConfiguration();
        const defaultLanguageProvidedData: LanguageConfiguration | null = MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.LANG_SWITCHER) ?
            MainHeaderApplicationDataProvider.parseProvidedData<LanguageConfiguration>(ScriptSelector.LANG_SWITCHER)
            : null;

        if (!defaultLanguageProvidedData) {
            mainHeaderApplicationData.langSwitcher = [ englishLanguageConfiguration ];

            return mainHeaderApplicationData;
        }

        const defaultLanguageData = this.getLanguageDataFrom(defaultLanguageProvidedData.lang.toLowerCase());

        if (!defaultLanguageData) {
            return mainHeaderApplicationData;
        }

        const defaultLanguageConfiguration: LanguageConfiguration = {
            lang: defaultLanguageData.languageISO,
            name: defaultLanguageProvidedData.name,
            icon: defaultLanguageData.icon,
        }

        mainHeaderApplicationData.langSwitcher = [
            defaultLanguageConfiguration,
            englishLanguageConfiguration,
        ];

        return mainHeaderApplicationData;
    }

    private static getLanguageDataFrom(languageISO: string): LanguageData | null {
        const languageCode = languageISO === 'si' ? LanguageCode.Slovenian : languageISO;
        const languageData = this.availableLanguages.find((languageState) => languageState.languageISO === languageCode);

        if (!languageData) {
            return null;
        }

        return languageData;
    }

    private static getEnglishLanguageConfiguration(): LanguageConfiguration {
        return {
            lang: LanguageCode.English,
            name: "English",
            icon: IconName.UnitedKingdom,
        };
    }

}